/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_SpecialistsInputs */

const en_find_specialists = /** @type {(inputs: Find_SpecialistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specialists`)
};

const pl_find_specialists = /** @type {(inputs: Find_SpecialistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specjaliści`)
};

/**
* | output |
* | --- |
* | "Specialists" |
*
* @param {Find_SpecialistsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const find_specialists = /** @type {((inputs?: Find_SpecialistsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_SpecialistsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_find_specialists(inputs)
	return en_find_specialists(inputs)
});